import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { addDoc, collection } from "firebase/firestore";
import { db, auth } from "../../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { Comment } from "./Comments";

interface FormData {
  text: string;
}
interface Props {
  commentId: string;
  postId: string;
  text: string;
  getComments?: () => void;
}

export const CommentForm = (props: Props) => {
  const { commentId, postId, text, getComments } = props;
  const schema = yup.object().shape({
    text: yup.string().required("Comment cannot be empty!"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: yupResolver(schema) });

  const navigate = useNavigate();

  const [user, loading, error] = useAuthState(auth);
  const postRef = collection(db, "comments");

  const onCreateComment = async (data: FormData) => {
    try {
      if (!user) {
        return;
      }
      await addDoc(postRef, {
        ...data,
        parentCommentId: commentId,
        commentId: commentId,
        postId: postId,
        userId: user.uid,
        username: user.displayName,
      });
      getComments && getComments();
      // navigate("/comments");
    } catch (error) {}
  };

  return (
    <form onSubmit={handleSubmit(onCreateComment)} className='form comment-form'>
      <div className='d-flex'>
        <input placeholder='Comment..' type='text' id='title' className='form-control' {...register("text")} />
        <input type='submit' className='btn btn-success ms-2 px-4' value='Send' />
      </div>
      {errors.text && <p className='alert alert-danger py-1 my-1'>{errors.text?.message}</p>}
    </form>
  );
};
